import * as React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

const NotFound: React.FC = () => {
  return (
    <div
      data-testid="page-not-found"
      className="flex min-h-[60vh] flex-col items-center justify-center text-center"
    >
      <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-secondary">
        <Compass className="h-6 w-6 text-muted-foreground" strokeWidth={1.5} />
      </div>
      <span className="eyebrow">404</span>
      <h1 className="mt-2 font-serif text-4xl text-foreground sm:text-5xl">
        Sayfa bulunamadı
      </h1>
      <p className="mt-3 max-w-md text-sm text-muted-foreground">
        Aradığınız sayfa taşınmış veya henüz eklenmemiş olabilir. Lütfen
        menüden bir bölüm seçin.
      </p>
      <Button asChild className="mt-6">
        <Link to="/dashboard" data-testid="notfound-home-link">
          Genel Bakış'a dön
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
